







































import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import SelectBase from '@/components/common/atoms/SelectBase.vue'
import { StudyData } from '@/mixins/requests/admin/StudyListApis.vue'
import { AssignStatusType } from '@/mixins/requests/admin/StudyListForAssignApis.vue'

@Component({
  components: {
    ButtonBase,
    SelectBase,
  },
})
export default class StudentTable extends Vue {
  @Prop()
  private studyList!: StudyData[]
  @Prop()
  private assignStatusCheckboxes!: AssignStatusType[]
  @Prop()
  private onClickPublishButton!: (studyContentId: number, questionId: number) => void
  @Prop()
  private onClickAssignButton!: (studyContentId: number, questionId: number) => void

  private colortype(isPublic: boolean): string {
    return isPublic ? 'pointer-events-none' : 'default'
  }

  private answerFormatText(): string {
    // TODO: 解答形式の種別仕様が決まり次第実装
    return '記述式'
  }

  private assignStatusText(statusValue: string): string {
    const assignStatus = this.assignStatusCheckboxes.find(
      (assignStatusCheckbox: AssignStatusType) => assignStatusCheckbox.statusValue === statusValue
    )
    return assignStatus ? assignStatus.statusText : ''
  }
}
